const createOrder = require('./create-order');
const onCancel = require('./cancel');
const onApprove = require('./approve-order');
const onShippingChange = require('./shipping-update');

module.exports = {
	createOrder,
	onCancel,
	onApprove,
	onShippingChange,
};
